import React from 'react';

import styles from "../DashboardFileManagement/DashboardFileManagement.module.css"
// import archiveStyles from "../DashboardArchivedFiles/ArchiveDetail/ArchiveDetail.module.css"

export default function FileOwnerAndConsultantData(props) {
    return (
        <>
            <div className='w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-4 mb-4 px-4'>
                {/* <div className={styles.title}>
                    اطلاعات مشاور و مالک
                </div>
                <div className='w-100 d-flex align-items-center my-4 flex-wrap'>
                    <div className={`d-flex align-items-center justify-content-start my-md-0 my-3 ${archiveStyles.archive_title_container}`}>
                        <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                            <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                <h5 className={styles.card_main_detail_text1}>نام مشاور</h5>
                                <div className={styles.card_main_detail_text2}>
                                    {props.cardDetailData?.ownerDetail.fullName}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`d-flex align-items-center justify-content-start my-md-0 my-3 ${archiveStyles.archive_title_container}`}>
                        <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                            <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                <h5 className={styles.card_main_detail_text1}>
                                    اطلاعات مشاور
                                </h5>
                                <div className={`d-flex align-items-center ${styles.card_main_detail_text2}`}>
                                    <h5 className={`m-0 ${styles.card_main_detail_text1}`}>
                                        {props.cardDetailData?.ownerDetail.phoneNumber.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}


                {/* files private data */}
                {props.cardDetailData?.infos &&
                    <div className='w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3'>
                        <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mb-4'>
                            <div className={styles.card_title}>
                                اطلاعات خصوصی فایل
                            </div>
                        </div>
                        <div className={`w-100 d-flex align-items-center justify-content-center flex-wrap px-2 ${styles.consultants_container}`}>
                            {props.cardDetailData?.infos?.map((item, i) => (
                                <div key={item.id} className={`w-100 d-flex align-items-center justify-content-center flex-wrap my-md-2 my-3`}>
                                    <div className='w-100 d-flex align-items-center justify-content-between flex-wrap px-3 py-2 text-end'>
                                        <div className={`col-md-3 my-md-0 my-2 ${styles.consultant_text1}`}>
                                            {props.limitData?.find((item) => item === "EstateInfoFullName")
                                                ?
                                                <></>
                                                :
                                                item.fullName?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
                                            }
                                        </div>
                                        <div className={`col-md-3 my-md-0 my-2 ${styles.consultant_text1}`}>
                                            {props.limitData?.find((item) => item === "EstateInfoPhoneNumber")
                                                ?
                                                <></>
                                                :
                                                item.phoneNumber?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
                                            }
                                        </div>
                                        <div className={`col-md-3 my-md-0 my-2 ${styles.consultant_text1}`}>
                                            {props.limitData?.find((item) => item === "EstateInfoResponsibility")
                                                ?
                                                <></>
                                                :
                                                item.responsibility?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
                                            }
                                        </div>
                                    </div>
                                    <hr className="solid w-100" />
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>
        </>
    )
}
